import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GameList } from 'src/app/models/common.model';
import { ConstantService } from 'src/app/service/constant.service';
import { GamesService } from 'src/app/service/games.service';
// import SwiperCore, { Navigation, SwiperOptions } from 'swiper/core';
import {
  SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
// SwiperCore.use([Navigation]);
@Component({
  selector: 'app-news-header',
  templateUrl: './news-header.component.html',
  styleUrls: ['./news-header.component.styl']
})
export class NewsHeaderComponent implements OnInit {
  gameList: any = [];
  public keepOriginalOrder = (a, b) => a.key;
  displayDropdown: boolean = false;
  @ViewChild(SwiperComponent) componentRef: SwiperComponent;
  // tslint:disable-next-line: member-ordering
  public config: SwiperConfigInterface = {
    slidesPerView: 5,
    preventClicks: true,
    preventClicksPropagation: true,
    // keyboard: true,
     mousewheel: true,
    // scrollbar: false,
    navigation: true,
    // pagination: false,
    centeredSlides: false,
    loop: false,
    observer: true,
    spaceBetween: 10,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    loopedSlides: 23,
    slidesPerGroup: 1,
    allowTouchMove: true,
    freeMode: true,
    initialSlide:0,
    breakpoints: {
      1200: {
        slidesPerView: 5
      },
      991: {
        slidesPerView: 5
      },
      768: {
        slidesPerView: 3
      },
      640: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      },
      360: {
        slidesPerView: 1
      },
      320: {
        slidesPerView: 1
      },
      0: {
        slidesPerView: 1
      }
    },
  };
  // public config: SwiperConfigInterface = {
  //   centeredSlides: true,
  //   loop: true,
  //   observer: true,
  //   spaceBetween: 10,
  //   slideToClickedSlide: false,
  //   slidesPerView: 'auto',
  //   slidesPerGroup: 1,--
  //   watchSlidesVisibility: true,
  //   loopedSlides: 9,
  //   allowTouchMove: true,
  //   navigation: true
  // };

  CurrentGame: GameList = {
    BetCount: null,
    Description: null,
    GameCode: null,
    GameID: null,
    ImagePath: null,
    IsIframe: null,
    IsLive: null,
    Name: null,
    Rules: null
  };
  Code: any;
  Token = '';
  IsCallMade = false;
  @Output() GameUrl = new EventEmitter();
  SelectedGame: any = {};

  // config: SwiperOptions = {
  //   // pagination: { el: '.swiper-pagination', clickable: true },
  //   autoHeight: true,
  //   allowTouchMove: true,
  //   hashNavigation: true,
  //   breakpoints: {
  //     1199: {
  //       slidesPerView: 8
  //     },
  //     1024: {
  //       slidesPerView: 6
  //     },
  //     768: {
  //       slidesPerView: 5
  //     },
  //     640: {
  //       slidesPerView: 4
  //     },
  //     480: {
  //       slidesPerView: 3
  //     },
  //     360: {
  //       slidesPerView: 3
  //     },
  //     320: {
  //       slidesPerView: 3
  //     }
  //   },
  //   // navigation: {
  //   //   nextEl: '.swiper-button-next',
  //   //   prevEl: '.swiper-button-prev'
  //   // },
  //   loop: true
  // };

  // SwiperCore.use([Pagination]);
  GameCode = '';


  constructor(
    public constant: ConstantService, public gameService: GamesService, private toastr: ToastrService, public translateService: TranslateService) {
    // this.GameList = this.constant.GameList;
  }

  ngOnInit() {
    const Url = sessionStorage.getItem('GameUrl') ? JSON.parse(sessionStorage.getItem('GameUrl')) : '';
    if (Url) {
      this.GameCode = Url ? new URL(Url).pathname.replace('/', '') : '';

      let Token = Url?.split('?')[1] || '';
      Token = Token?.split('=')[1] || '';
      this.Code = Url?.split('/')[3] || '';
      this.Code = this.Code?.split('?')[0] || '';
    }
    this.Token = sessionStorage.getItem('AuthToken');
    if (this.Token !== '' || Url) {
      this.getcommonList();
    }
  }

  async GetMarketHistory() {
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    window.open(location.origin + '/history?Token=' + Token, '_blank');
  }

  UserName() {
    if (this.constant.displayNameLive != '' && this.constant.displayNameLive != 'Null' && this.constant.displayNameLive != undefined) {
      return this.constant.displayNameLive;
    } else if (this.constant.displayNameVirtual != '' && this.constant.displayNameVirtual != 'Null' && this.constant.displayNameVirtual != undefined) {
      return this.constant.displayNameVirtual;
    } else if (this.constant.userName != '' && this.constant.userName != 'Null' && this.constant.userName != undefined) {
      return this.constant.userName;
    } else {
      return 'UserName';
    }
  }

  getGameUrl(item, index) {
    this.constant.isIfreameLodded = true;
    if (!this.constant.isClassicView) {
      // let isVirtualOrDealer = item.GameUrl.split('/');
      // console.log(isVirtualOrDealer);
      if (this.constant.isClassicView == false) {
        item.GameUrl = this.constant.ReplaceGameUrl(item.GameUrl);
      }
      // if (isVirtualOrDealer[2] === 'virtual.supernowa.net') {
      //   item.GameUrl = item.GameUrl.replace('https://virtual.supernowa.net', 'https://designrnggame.supernowa.net');
      // } else {
      //   // item.GameUrl = item.GameUrl.replace('https://staginglive.supernowa.net', 'https://designlobby.supernowa.net/');
      //   item.GameUrl = item.GameUrl.replace('https://live.supernowa.net', 'https://designlivegame.supernowa.net');
      // }
    }
    this.GameCode = item.GameCode;
    this.constant.gameId = item.GameID;
    sessionStorage.setItem('GameIndex', index);
    sessionStorage.setItem('GameName', JSON.stringify(item.Name));
    this.constant.gameName = item.Name;
    if (item.GameType === 'PowerGame') {
      window.open(item.RedirectUrl, '_blank');
    } else {
      this.GameUrl.emit(item.GameUrl);
    }
  }

  gameNameSet(item) {
    if (item && !item.includes('Virtual')) {
      return 'Live ' + item;
    } else {
      return item;
    }
  }
  setCurrentSlider(GameCode) {
    let GameIndex = 0;
    this.constant.tmpGameList.find(function (item, i) {
      if (item.GameCode.trim() === String(GameCode)) {
        GameIndex = i;
      }
    });
    this.config.initialSlide = GameIndex;
  }

  getcommonList() {
    this.gameList = sessionStorage.getItem('GameList') ? JSON.parse(sessionStorage.getItem('GameList')) : [];
    this.constant.gameName = sessionStorage.getItem('GameName') ? JSON.parse(sessionStorage.getItem('GameName')) : '';
    // this.constant.newsList = JSON.parse(sessionStorage.getItem('NewsList'));
    // this.gameList.push(this.powergame);
    this.constant.tmpGameList = this.gameList.filter(item => item.GameType != 'PowerGame');
    // console.log(this.constant.hedarGameList);
    // console.log(this.GameCode.trim());
    // if (sessionStorage.getItem('GameIndex')) {
    //   this.setCurrentSlider(sessionStorage.getItem('GameIndex'));
    // }
    // else {
    //   this.setCurrentSlider(0);
    // }
    this.setCurrentSlider(this.GameCode.trim());
  }
  checkGameStatus(game, index) {
    let gametype = 'Live'
    if (game.Name && (game.Name.includes('Virtual') || game.Name.includes('Rng') || game.Name.includes('RNG'))) {
      gametype = "Virtual";
    }
    let gameDetail = {
      GameCode: game.GameCode.trim(),
      GameType: gametype,
      ClientUsername: this.constant.userName,
    };
    this.gameService.CheckGameStatus(gameDetail).subscribe((data) => {
      let gameDetail = null;
      let GameIndex = 0;
      if (data.data.Code === '1') {
        gameDetail = this.constant.tmpGameList.find(function (item, i) {
          if (item.GameCode.trim() === data.data.GameCode.trim()) {
            GameIndex = i;
            return i;
          }
        });
        this.toastr.error(data.data.ResMessage);
        if(gameDetail != null && gameDetail != undefined && gameDetail != ''){
          this.getGameUrl(gameDetail, GameIndex);
        }
      } else {
        this.getGameUrl(game, index);
      }
    });
  }
  GetGameDetails(GameCode) {
    let index = -1;
    index = this.constant.tmpGameList.findIndex(function (item, i) {
      return item.GameCode.trim() === GameCode.trim()
    });
    setTimeout(() => {
      if (index >= 0) {
        this.checkGameStatus(this.constant.tmpGameList[index], index)
      }
    }, 100);

  }
  SliderGameName(name) {
    let value = name.replaceAll('Virtual', 'RNG').toUpperCase();
    let GameShorName = value.replace(/[^a-zA-Z0-9]/g, '')
    let GameValue = value + '1';
    this.translateService.get(GameShorName).subscribe(data => {
      // console.log(data);
      GameValue = data + '2';
    }, err => {
      GameValue = value + 'err';
    });
    return GameValue;
    // .subscribe(
    //   value => { return value }, err => { this.IsCallMade = false; });
    // );
    // return value.replace(/[^a-zA-Z0-9]/g, '');
  }
  public onIndexChange(index: number): void {
    $('.swiper-slide').on('click', (data) => {
      let gameCode = data.target.getAttribute("gamecode").trim();
      // console.log(gameCode);
      if (this.GameCode !== gameCode) {
        this.GetGameDetails(gameCode);
      }
    });
  }
}

